import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ApiResponse } from "../../utils";
import Config from "../../../app.config";

const baseUrl = Config.INTERNAL_GATEWAY_URL;
const userName = Config?.UserName ?? "";
const password = Config?.Password ?? "";
const tenantId = Config?.tenantId ?? "";
const TokenApi = createApi({
  reducerPath: "TokenApi",
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => {
      if (!headers.get("TenantId")) headers.set("TenantId", tenantId);
      headers.set("Access-Control-Allow-Origin", "*");
      headers.set("x-api-key","jlH0gFOpUMHRpTZISNcUjGLVx5HOAwtj")
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getToken: builder.query({
      query: (body) => ({
        url: `/authentication`,
        method: "POST",
        headers: { TenantId: body?.tenantId },
        body: { data: { username:body?.userName ?? userName , userIdentifier: body?.userName ?? userName, password: body?.password ?? password, rememberMe: true } },
      }),
      transformResponse: (response: ApiResponse) => {
        return response.result;
      },
    }),
  }),
});
export const { useGetTokenQuery, useLazyGetTokenQuery } = TokenApi;
export default TokenApi;
